import pick from 'lodash/pick'

const getData = ({ dataIds, data, noArticles }) => {
  if (dataIds.length === 1 && noArticles) return data[dataIds[0]]
  if (dataIds.length > 0) return pick(data, dataIds)
}

export default getData
